module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAbCAMAAABY1h8eAAAAh1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9qkf8RAAAALHRSTlMAwEY5LPyCmd65+de8NxsUEQ0L5bVrUwf27enPy6KfeXRlX1kxIauPjoyLTpmjAdAAAADYSURBVCjP5ZJnrsJAEIMnm60JCen08iiv4fufDzIDf9jcgE+KbMmSPYqWHujvJOZ3QYxvJ0JjORtwo5hZzpJ4muALelzEcSqcc69bViTEvdXSsZ/s/Xl8jC1FS/vqddQ9z7liJ2aHqxgfyGYN2zNmzy2cWZvM0sXwZuXXUKNRWHu+0JkLkUUYir7Nio35V+rPbIqs7YshgLdPKwBbTbUzgHE16S2A1YkErUqZSdNGLlb69S/2NUXU+zmrQhqHKdRHhRp9HB6gxQTkyRs5AgmLY/cedofxwd8BTpMQq/SShrcAAAAASUVORK5CYII="


/*****************
 ** WEBPACK FOOTER
 ** ./images/icon-shop.png
 ** module id = 183
 ** module chunks = 3
 **/